import React from 'react';
import FormSelect from 'shared/forms/FormSelect';

const CustomerSearchEntityFieldsDropdown = ({ entity = 'orders', ...props }) => {
    const ordersFields = [
        {
            description: 'Pro Number',
            value: 'ProNumber'
        },
        {
            description: 'Master Pro Number',
            value: 'MasterOrderId'
        },
        {
            description: 'Equipment Number',
            value: 'EquipmentNumber'
        },
        {
            description: 'BOL/Booking/Reference',
            value: 'BolBkgRef'
        },
        {
            description: 'PO',
            value: 'PurchaseOrderNumber'
        },
        {
            description: 'Chassis #',
            value: 'ChassisNumber',
        },
        {
            description: 'Quote #',
            value: 'QuoteId'
        },
        {
            description: 'Invoice Ref #',
            value: 'InvoiceReferenceNumber'
        },
        {
            description: 'Appointment #',
            value: 'AppointmentNumbers'
        }
    ]

    const entitiesFields = {
        orders: ordersFields
    }

    return <FormSelect data={entitiesFields[entity]} textField="description" dataItemKey="value" {...props} />;
};

export default CustomerSearchEntityFieldsDropdown;
